import { render, staticRenderFns } from "./CampsPanel.vue?vue&type=template&id=38e1b6a0&scoped=true&"
import script from "./CampsPanel.vue?vue&type=script&lang=js&"
export * from "./CampsPanel.vue?vue&type=script&lang=js&"
import style0 from "./CampsPanel.vue?vue&type=style&index=0&id=38e1b6a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e1b6a0",
  null
  
)

export default component.exports